<template>
  <div class="case-search-condition">
    <div class="right-float">
      <slot name="right-float" />
    </div>
    <div class="case-search-condition-content">
      <span class="info-tip">检索条件:</span>
      <div class="full-text-search-warp" v-for="(arr, name) in groupList">
        <div class="word-normal word-color2 filter-tag-warp" :key="name">
          <div class="filter-name">{{ name }}</div>
          <div class="filter-right">
            <span v-for="(i, idx) in arr" class="filter-tag">
              {{ i.value }}
              <i v-if="remove" class="el-icon-close close-btn" @click="removeFilter(i, idx)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from 'lodash';

export default {
  data() {
    return {
      paragraphArr: [],
      groupList: []
    };
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    remove: {
      type: Boolean,
      default: false
    },
    instrumentType: {
      type: String,
      default: ''
    }
  },
  watch: {
    list: {
      handler: function() {
        this.init();
      },
      deep: true
    }
  },
  methods: {
    init() {
      this.groupList = groupBy(this.list, 'name');
    },
    removeFilter(obj) {
      this.$emit('removeFilter', obj);
    }
  }
};
</script>

<style lang="less" scoped>
.case-search-condition {
  box-sizing: border-box;
  width: 100%;
  position: relative;
  // display: flex;
  line-height: 30px;
  background: #fff;
  padding: 20px 20px 10px;

  .right-float {
    float: right;
  }
  .case-search-condition-content {
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    transition-duration: 0.3s;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .label {
      position: absolute;
      top: 0;
      left: 0;
    }
    &.is-put {
      height: 80px;
      overflow: hidden;
    }
    .info-tip {
      font-size: 14px;
      color: #666666;
      margin-right: 14px;
    }
  }
  .label {
    margin-right: 15px;
  }
  .full-text-search-warp {
    position: relative;
    margin-right: 20px;
    .full-text-group-type {
      position: absolute;
      left: 80px;
      font-size: 12px;
      top: 50%;
      margin-top: -4px;
      transform: translateY(-50%);
      z-index: 2;
      user-select: none;

      .group-type-btn {
        display: flex;
        flex-direction: column;
        cursor: pointer;

        .group-text {
          color: #999999;
          background-color: #f5f5f5;
          line-height: 20px;
          padding: 0 2px;

          &.active {
            color: #e42626;
            background-color: #ffeaea;
          }
        }

        &.not-allowed {
          cursor: not-allowed;
        }
      }
    }

    .line {
      display: inline-block;
      background: #ddd;
      width: 1px;
      position: absolute;
      left: 87px;
      height: calc(100% - 14px);
      top: calc(50% - 4px);
      transform: translateY(-50%);
      .line-item {
        contain: '';
        display: block;
        height: 1px;
        width: 10px;
        background: #ddd;
        position: relative;
      }
      .line-item-top {
        position: absolute;
        top: 0;
      }
      .line-item-bottom {
        position: absolute;
        bottom: 0;
      }
    }
  }

  .filter-tag-warp {
    display: flex;
    flex-direction: row;
  }
  .filter-name {
    display: inline-block;
    // width: 110px;
    margin-right: 10px;
    color: #2c7ddc;
    font-size: 14px;
  }

  .filter-right {
    // max-width: 70%;
    display: flex;
    flex-direction: row;
  }
  .filter-tag {
    align-self: baseline;
    word-wrap: break-all;
    padding: 0 10px;
    // padding-right: 28px;
    text-align: left;
    line-height: 30px;
    margin-bottom: 10px;
    color: #666;
    margin-right: 5px;
    background: #f5f5f5;
    border-radius: 4px;
    display: inline-block;
    width: auto;
    .close-btn {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lawSearchInfo.vue